import { render, staticRenderFns } from "./customFirst.vue?vue&type=template&id=b029814a&scoped=true&"
import script from "./customFirst.vue?vue&type=script&lang=ts&setup=true&"
export * from "./customFirst.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./customFirst.vue?vue&type=style&index=0&id=b029814a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b029814a",
  null
  
)

export default component.exports